if (!customElements.get("product-content")) {
  class ProductContent extends HTMLElement {
    constructor() {
      super();

      this.popupVideo = document.querySelector("popup-video");
      this.popupIframe = this.popupVideo.querySelector("[data-popup-iframe]");

      this.addEventListener("click", (e) => {
        e.preventDefault();

        const link = e.target.closest("a");
        const isVideoLink =
          link?.title.includes("video") && link.href.includes("youtube");

        if (!(link && isVideoLink)) return;

        const linkParameters = new URLSearchParams(link.search);
        const videoId = linkParameters.get("v");

        this.popupIframe.src = `https://www.youtube.com/embed/${videoId}?enablejsapi=1`;

        this.popupVideo.open();
      });
    }
  }

  customElements.define("product-content", ProductContent);
}
